import { Provider } from "@redotech/redo-order-common/provider";
import type { FulfillmentGroupData } from "./fulfillment-group";
import { FulfillmentGroupStatus } from "./fulfillment-group-status";

const CANCELABLE_ORDER_PROVIDERS = new Set<Provider>([
  Provider.SHOPIFY,
  Provider.BIGCOMMERCE,
  Provider.WALMART,
  Provider.MANUAL,
  Provider.REDO,
  Provider.REDO_MARKETPLACE,
  Provider.LINNWORKS_DIRECT,
]);

// Redo-native orders have no marketplace to settle with, so they can also be
// cancelled while payment is still pending.
const PAYMENT_PENDING_CANCELABLE_PROVIDERS = new Set<Provider>([Provider.REDO]);

export function canCancelFulfillmentGroups(
  fulfillmentGroups: readonly Pick<
    FulfillmentGroupData,
    "providers" | "status"
  >[],
): boolean {
  return (
    fulfillmentGroups.length === 1 &&
    fulfillmentGroups.every((fg) => {
      if (fg.providers?.length !== 1) {
        return false;
      }

      const [provider] = fg.providers;
      if (provider == null || !CANCELABLE_ORDER_PROVIDERS.has(provider)) {
        return false;
      }

      if (
        fg.status === FulfillmentGroupStatus.Open ||
        fg.status === FulfillmentGroupStatus.OnHold
      ) {
        return true;
      }

      return (
        fg.status === FulfillmentGroupStatus.PaymentPending &&
        PAYMENT_PENDING_CANCELABLE_PROVIDERS.has(provider)
      );
    })
  );
}
